/*
  Panel "Completa el look" del carrito (estilo rhythmlivin.com).
  - Se actualiza cada vez que se abre el carrito o cambia su contenido.
  - Usa el producto agregado más reciente del carrito como referencia.
  - Primero muestra los productos elegidos a mano (metacampo custom.complete_the_look);
    si no hay, usa las recomendaciones automáticas de Shopify.
  - Nunca sugiere productos que ya están en el carrito.
*/
(function () {
  if (window.__completeTheLookInitialized) return;
  window.__completeTheLookInitialized = true;

  var LIMIT = 4;
  var cache = {};
  var runId = 0;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var CHEVRON =
    '<svg viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M5 2l5 5-5 5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function getDialogs() {
    return document.querySelectorAll('.cart-drawer__dialog');
  }

  function ensureToggle(dialog) {
    var panel = dialog.querySelector('.complete-the-look-panel');
    if (!panel || panel.querySelector('.complete-the-look-panel__toggle')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'complete-the-look-panel__toggle';
    btn.setAttribute('aria-label', 'Mostrar u ocultar Completa el look');
    btn.setAttribute('aria-expanded', 'true');
    btn.innerHTML = CHEVRON;
    panel.insertBefore(btn, panel.firstChild);
  }

  function setPanel(html) {
    getDialogs().forEach(function (dialog) {
      var container = dialog.querySelector('.complete-the-look-panel__items');
      if (!container) return;
      ensureToggle(dialog);
      if (html) {
        container.innerHTML = html;
        dialog.setAttribute('data-has-recommendations', 'true');
      } else {
        container.innerHTML = '';
        dialog.removeAttribute('data-has-recommendations');
      }
    });
  }

  function fetchItems(url) {
    if (cache[url]) return Promise.resolve(cache[url]);
    return fetch(url)
      .then(function (res) {
        return res.ok ? res.text() : '';
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var source = doc.getElementById('complete-the-look-products');
        var items = source ? Array.prototype.slice.call(source.querySelectorAll('.complete-the-look-item')) : [];
        cache[url] = items;
        return items;
      })
      .catch(function () {
        return [];
      });
  }

  function buildHtml(items, excludeIds) {
    var out = [];
    items.forEach(function (item) {
      var id = item.getAttribute('data-product-id');
      if (out.length < LIMIT && excludeIds.indexOf(id) === -1) out.push(item.outerHTML);
    });
    return out.join('');
  }

  function refresh() {
    var run = ++runId;
    fetch(root + 'cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (run !== runId) return;
        if (!cart.items || !cart.items.length) {
          setPanel('');
          return;
        }

        var inCart = cart.items.map(function (i) {
          return String(i.product_id);
        });

        var anchor = null;
        var lastHandle = window.__lastAddedProductHandle;
        if (lastHandle) {
          anchor = cart.items.filter(function (i) {
            return i.handle === lastHandle;
          })[0];
        }
        if (!anchor) anchor = cart.items[0];

        return fetchItems(root + 'products/' + anchor.handle + '?section_id=complete-the-look')
          .then(function (items) {
            var html = buildHtml(items, inCart);
            if (html) return html;
            return fetchItems(
              root +
                'recommendations/products?product_id=' +
                anchor.product_id +
                '&limit=10&intent=related&section_id=complete-the-look'
            ).then(function (recs) {
              return buildHtml(recs, inCart);
            });
          })
          .then(function (html) {
            if (run === runId) setPanel(html || '');
          });
      })
      .catch(function () {});
  }

  // Refrescar al abrir el carrito
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.attributeName === 'open' && m.target.hasAttribute('open')) refresh();
    });
  });

  function observeDialogs() {
    getDialogs().forEach(function (dialog) {
      ensureToggle(dialog);
      if (dialog.__ctlObserved) return;
      dialog.__ctlObserved = true;
      observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDialogs);
  } else {
    observeDialogs();
  }

  // Refrescar cuando cambia el carrito (agregar, quitar, cambiar cantidad)
  document.addEventListener('cart:update', function (event) {
    var data = (event.detail || {}).data || {};
    if (data.didError) return;
    observeDialogs();
    refresh();
  });

  // Flecha para contraer / expandir el panel
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('.complete-the-look-panel__toggle');
    if (!btn) return;
    var dialog = btn.closest('.cart-drawer__dialog');
    if (!dialog) return;
    var collapsed = dialog.getAttribute('data-ctl-collapsed') === 'true';
    dialog.setAttribute('data-ctl-collapsed', collapsed ? 'false' : 'true');
    btn.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
  });
})();
